var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferFriendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;}.cls-1,.cls-2{stroke-width:0.5px;}.cls-2{fill:#d68828;stroke:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-1",
    d: "M62.53,55.74a1.13,1.13,0,0,1-1.13-1.13h0c0-12.08-4-18.2-11.76-18.2s-11.75,6.12-11.75,18.2a1.14,1.14,0,0,1-2.27,0c0-16.92,7.63-20.47,14-20.47s14,3.55,14,20.47a1.14,1.14,0,0,1-1.14,1.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-2",
    d: "M36.75,55.74a1.13,1.13,0,0,1-1.13-1.13h0c0-12.08-4-18.2-11.76-18.2s-11.75,6.12-11.75,18.2a1.14,1.14,0,0,1-2.27,0c0-16.92,7.63-20.47,14-20.47s14,3.55,14,20.47a1.14,1.14,0,0,1-1.14,1.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-1",
    d: "M49.64,30a7.59,7.59,0,1,1,7.58-7.59h0A7.59,7.59,0,0,1,49.64,30Zm0-12.89a5.29,5.29,0,1,0,5.29,5.29,5.29,5.29,0,0,0-5.29-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-2",
    d: "M23.86,30a7.59,7.59,0,1,1,7.58-7.59v0A7.59,7.59,0,0,1,23.86,30Zm0-12.89a5.29,5.29,0,1,0,5.29,5.29,5.29,5.29,0,0,0-5.29-5.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferFriendIcon);
export default __webpack_public_path__ + "static/media/refer-friend-icon.fc3997b3ccb3afdee16f7fdbe2f82386.svg";
export { ForwardRef as ReactComponent };